






























import { Component, Vue } from "vue-property-decorator";
import PostCard from "../blog/PostCard.vue";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import store from "../../core/store";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

@Component({
  components: { PostCard, VueSlickCarousel },
})
export default class LastPosts extends Vue {
  posts: any[] = [];

  get carouselSettings() {
    const count = this.visiblePosts.length;
    const hasMany = count > 1;
    if (count <= 1) {
      return {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0px",
        variableWidth: true,
        autoplay: false,
        speed: 900,
        autoplaySpeed: 4500,
        cssEase: "ease-in-out",
        draggable: false,
        swipe: false,
        touchMove: false,
      };
    }
    return {
      arrows: false,
      dots: false,
      infinite: hasMany,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      variableWidth: true,
      autoplay: this.visiblePosts.length > 2,
      speed: 900,
      autoplaySpeed: 4500,
      cssEase: "ease-in-out",
    };
  }

  get carouselClass() {
    const count = this.visiblePosts.length;
    if (count <= 1) return "lastPostsCarousel--single";
    if (count === 2) return "lastPostsCarousel--double";
    return "";
  }

  get gridClass() {
    const count = this.visiblePosts.length;
    if (count <= 1) return "lastPostsGrid--single";
    if (count === 2) return "lastPostsGrid--double";
    return "";
  }

  get visiblePosts() {
    return (this.posts || []).slice(0, 3);
  }

  async mounted() {
    const url = `${Settings.HostName}/api/cztextblocks/list-with-users?count=3`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting last posts");
      return;
    }
    this.posts = data;
    this.$emit("loaded", this.visiblePosts.length);
  }

  getImage(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }
}
